import useIntersectionObserver from '@/hooks/shared/useIntersectionObserver';

import BlurImage from '@/components/shared/ui/BlurImage';

import { MikeItemType } from './solutionItemTypes';

const MIKE_IMAGE_SIZES =
  '(min-width: 1280px) 728px, (min-width: 1024px) 50vw, calc(100vw - 40px)';

type SolutionMikeProps = {
  mike: MikeItemType[];
  isDesktop: boolean;
};

export default function SolutionMike({ mike, isDesktop }: SolutionMikeProps) {
  const container = useIntersectionObserver<HTMLDivElement>({
    selector: '[data-reveal-item]',
    staggerMs: 100,
  });

  return (
    <div ref={container}>
      <div className="flex flex-col gap-[60px]">
        {/*
          MikeItem 의 xl 그리드는 원본이 `grid-template-columns: 1fr 1fr` 이다.
          Tailwind 의 xl:grid-cols-2 는 `repeat(2, minmax(0, 1fr))` 라 트랙 최소값이
          달라지므로 임의값으로 원본 그대로 옮긴다.
        */}
        {mike.map((mic, index) => (
          <div
            key={index}
            className="grid gap-4 xl:grid-cols-[1fr_1fr] xl:gap-6"
          >
            <div
              data-reveal-item
              className="intersection-reveal text-[20px] font-bold leading-[140%] tracking-[-0.4px] text-apps-coreGray01 xl:col-span-2 xl:text-[clamp(20px,2.333vw,28px)] xl:tracking-[-0.56px]"
            >
              {mic.title}
            </div>
            <div
              data-reveal-item
              className="intersection-reveal relative aspect-[335/247] overflow-hidden rounded-[20px] xl:aspect-[540/398]"
            >
              {/*
                원본 StyledImage 의 position: relative 는 next/image 의 fill 이
                inline style 로 position: absolute 를 넣기 때문에 적용된 적이 없다.
                Tailwind 는 모든 유틸리티가 !important 라 relative 를 붙이면
                inline style 을 이겨버려 동작이 바뀌므로 의도적으로 생략한다.
              */}
              <BlurImage
                className="object-cover"
                src={isDesktop ? mic.desktopImageSrc : mic.mobileImageSrc}
                fill
                sizes={MIKE_IMAGE_SIZES}
                alt={typeof mic.title === 'string' ? mic.title : ''}
                quality={86}
              />
            </div>
            <div className="-my-3 xl:-my-1">
              {mic.items.map((item, idx) => (
                <div
                  key={idx}
                  data-reveal-item
                  className="intersection-reveal grid grid-cols-[88px_auto] gap-4 px-0 py-3 [&:not(:last-child)]:border-b [&:not(:last-child)]:border-b-apps-coreProductDivider xl:grid-cols-[auto] xl:gap-1 xl:py-4"
                >
                  <div className="text-[14px] font-bold leading-[140%] tracking-[-0.28px] text-apps-brandGray50 lg:text-[16px] lg:tracking-[-0.32px]">
                    {item.title}
                  </div>
                  <div className="text-[14px] font-medium leading-[140%] tracking-[-0.28px] text-apps-brandGray300 lg:text-[16px] lg:tracking-[-0.32px]">
                    {item.description}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
